import React, { FC, useEffect, useState }                            from "react";
import { useDispatch, useSelector }                                  from "react-redux";
import { Button, Grid, Icon, Loader, Message, Segment, Step, Table } from "semantic-ui-react";
import GetPaymentInformation
                                                                     from "../../../application/usecase/payment/GetPaymentInformetion";
import RegisterPayJpCustomerToken
                                                                     from "../../../application/usecase/payment/RegisterPayJpCustomerToken";
import FetchStatus
                                                                     from "../../../domain/fundamentals/fetch/FetchStatus";
import { ResKaState }                                                from "../../../index";
import ValidatorMessage                                              from "../../components/message/ValidatorMessage";
import NotifyDisplay                                                 from "../../components/notify/NotifyDisplay";

declare global {
  interface Window {
    created: (response: any) => void;
    failed: (statusCode: string, errorResponse: any) => void;
  }
}
const PaymentRegister: FC = () => {
  const [planName, setPlanName] = useState("");
  const [price, setPrice] = useState("");
  const [message, setMessage] = useState("");
  const fetchStatus: FetchStatus = useSelector((state: ResKaState) => state.fetchStatus);
  const getPaymentInformation: GetPaymentInformation = new GetPaymentInformation(useDispatch());
  const registerPayJpCustomerToken: RegisterPayJpCustomerToken = new RegisterPayJpCustomerToken(useDispatch());

  const paymentCheckoutRef = React.createRef<HTMLDivElement>();
  const script: HTMLScriptElement = document.createElement("script");
  const onCreated = (response: any): void => {
    if (response.card.cvc_check === "unavailable" || response.card.cvc_check === "failed") {
      setMessage("利用ができないCVC番号です。お手数ですが、お客様のクレジットカード会社にご連絡ください。");
    } else {
      registerPayJpCustomerToken.execute(response.id);
    }
  };

  const onFailed = (statusCode: string, errorResponse: any): void => {
    const message: string = errorResponse.message;
    window.alert(`status: ${ statusCode }\n${ message }`);
  };

  useEffect(() => {
    script.setAttribute("src", "https://checkout.pay.jp/");
    script.setAttribute("class", "payjp-button");
    script.setAttribute("data-key", String(process.env.REACT_APP_PAY_JP_KEY));
    script.setAttribute("data-payjp", "38df419dd565f6a454646761976801dd5b8c4e3c");
    script.setAttribute("data-partial", "true");
    script.setAttribute("data-on-created", "created");
    script.setAttribute("data-on-failed", "failed");
    script.setAttribute("data-text", "クレジットカードで決済する");
    script.setAttribute("data-submit-text", "決済を確定する");

    if (paymentCheckoutRef && paymentCheckoutRef.current) {
      paymentCheckoutRef.current.appendChild(script);
    }

    window.created = onCreated;
    window.failed = onFailed;

    getPaymentInformation.execute(setPlanName, setPrice);
  }, []);

  return (
    <>
      <Loader active={ fetchStatus.isFetching() }/>
      <NotifyDisplay/>
      <Step.Group fluid>
        <Step completed disabled>
          <Icon name="check"/>
          <Step.Content>
            <Step.Title>お試し期間終了</Step.Title>
            <Step.Description>お試し期間が終了しました。</Step.Description>
          </Step.Content>
        </Step>
        <Step active>
          <Icon name="payment"/>
          <Step.Content>
            <Step.Title>お申込内容の確認</Step.Title>
            <Step.Description>お申込み時に選択したプランと金額を確認して、決済情報を入力してください。</Step.Description>
          </Step.Content>
        </Step>
        <Step disabled>
          <Icon name="info"/>
          <Step.Content>
            <Step.Title>決済完了</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>

      <Segment attached>
        <ValidatorMessage target="token"/>
        {
          message === ""
            ?
            null
            :
            <Message error>
              <Message.Header>決済に失敗しました。</Message.Header>
              <p>{ message }</p>
            </Message>
        }
        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>お申込み時選択プラン</Table.HeaderCell>
              <Table.HeaderCell>金額(月額)</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{ planName }</Table.Cell>
              <Table.Cell>{ price }円(税込)</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <div ref={ paymentCheckoutRef }/>
        <br/>
        <p>
          銀行振込をご希望の場合は下記、お問い合わせ窓口へご連絡ください。<br/>
          <small>※ 銀行振込の場合は複数月まとめてのお支払いとなります。</small>
        </p>
      </Segment>

      <Segment attached="bottom">
        <p>特定商取引法に基づく表記</p>
        <Grid columns={ 2 } celled={ true }>
          <Grid.Row>
            <Grid.Column>販売事業者名</Grid.Column>
            <Grid.Column>株式会社MareSpera</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>運営責任者名</Grid.Column>
            <Grid.Column>笠原&nbsp;拓</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>お問い合わせ窓口(メールアドレス)</Grid.Column>
            <Grid.Column>info@marespera.co.jp</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>お問い合わせ窓口(電話番号)</Grid.Column>
            <Grid.Column>042-518-9678</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>本社所在地</Grid.Column>
            <Grid.Column>東京都立川市曙町2-14-23&nbsp;東財曙町第二ビル&nbsp;2階</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>商品代金以外の必要料金</Grid.Column>
            <Grid.Column>銀行振込手数料</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>お支払い方法</Grid.Column>
            <Grid.Column>
              <ul>
                <li>クレジットカード決済</li>
                <li>銀行振込</li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>代金の支払い時期</Grid.Column>
            <Grid.Column>
              <ul>
                <li>カード決済：初回お申し込み時、翌月以降毎月月末に請求</li>
                <li>銀行振込：初回お申込みから翌月末まで、翌月以降毎月月末の請求書発行から翌月末までにお振込み</li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>商品の引き渡し期間</Grid.Column>
            <Grid.Column>ご購入手続き後、3営業日以内</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>返品・交換不良品・解約について</Grid.Column>
            <Grid.Column>HPからのお問い合わせ後、当月末に解約。翌月以降の請求を停止いたします。</Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      <Segment attached="bottom">
        <Button
          primary
          onClick={ () => window.location.href = "/notice" }
        >
          ResKaに戻る
        </Button>
      </Segment>
    </>
  );
};

export default PaymentRegister;
